<div class="vsa-page-container">
  <div class="content-container center">
      <mat-card class="mat-elevation-z0 card">
        <img src="assets/imgs/registration-confirmation-header-image.png">
        <mat-card-content style="height: 100%" class="center">
          <h1 class="confirmation-header" data-confirmation-header>Thank you for registering your account!</h1>
          <p class="confirmation-text">Please check your email for next steps.</p>
        </mat-card-content>
      </mat-card>
    </div>
  <app-footer footerTitle="Request a Login"></app-footer>
</div>
